// src/components/ScrollToTop.tsx
// React Router preserves scroll position across navigations, so pages open
// halfway down. This resets to top on every route change.
//
// AppLayout scrolls inside its own <main> container, not window (body is
// `overflow: hidden`), so window.scrollTo alone is a no-op there — reset
// the real container too, passed down as a ref from AppLayout.
import { useEffect, type RefObject } from 'react';
import { useLocation } from 'react-router-dom';

interface ScrollToTopProps {
  containerRef?: RefObject<HTMLElement | null>;
}

export const ScrollToTop = ({ containerRef }: ScrollToTopProps = {}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    if (containerRef?.current) {
      containerRef.current.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    }
  }, [pathname, containerRef]);

  return null;
};

export default ScrollToTop;
